import { isArray, isEmpty } from 'lodash-es'

import { defaultFilters, type TSearchFilter } from '@/entities/map'
import { RoomSortOption } from '@/entities/room'
import { isNilOrEmptyString } from '@/shared/lib'

export const convertToFilterSearchParams = (
  filters: TSearchFilter & { keyword?: string; sort?: RoomSortOption },
) => {
  const updatedParams = new URLSearchParams()

  Object.entries(filters).forEach(([key, value]) => {
    if (isNilOrEmptyString(value)) return
    if (isArray(value) && isEmpty(value)) return
    if (value === defaultFilters[key as keyof TSearchFilter]) return

    updatedParams.set(key, value.toString())
  })

  return updatedParams.toString()
}

export const convertToMapSearhParams = ({
  zoomLevel,
  center,
}: {
  zoomLevel: number
  center: { lat: number; lng: number }
}) => {
  const updatedParams = new URLSearchParams()

  updatedParams.set('lat', center.lat.toString())
  updatedParams.set('lng', center.lng.toString())
  updatedParams.set('zoomLevel', zoomLevel.toString())

  return updatedParams.toString()
}

export const convertToWebviewSearchParams = ({
  width,
  height,
  userId,
}: {
  width: string | null
  height: string | null
  userId: string | null
}) => {
  const updatedParams = new URLSearchParams()

  if (width) updatedParams.set('width', width)
  if (height) updatedParams.set('height', height)
  if (userId) updatedParams.set('userId', userId)

  return updatedParams.toString()
}
